import type {Nullable} from '@malt/types-utils';
import {SortType} from '@api';
import type {SortableHeaders} from '../types';

function mapFromSortType<T extends SortType | undefined>(value?: T): T extends Nullable<T> ? SortableHeaders | undefined : SortableHeaders;
function mapFromSortType<T extends SortType | undefined>(value?: T): SortableHeaders | undefined {
    if (value) {
        const reverseMapping: Record<SortType, SortableHeaders> = {
            [SortType.Action]: 'actions',
            [SortType.Total]: 'total',
            [SortType.Freelancer]: 'freelancer',
            [SortType.FreelancerPrice]: 'freelancerPrice',
            [SortType.ProjectOwner]: 'projectOwner',
            [SortType.PurchaseOrder]: 'purchaseOrder',
            [SortType.Company]: 'company',
            [SortType.Organization]: 'organization',
            [SortType.ProjectTitle]: 'title',
            [SortType.StartDate]: 'startDate',
            [SortType.EndDate]: 'endDate',
            [SortType.SortDateForClient]: 'sortDateForClient',
            [SortType.Status]: 'status',
            [SortType.VerticalType]: 'verticalType',
            [SortType.OpportunityType]: 'opportunityType',
            [SortType.RenewalStatus]: 'renewalStatus',
        };
        return reverseMapping[value];
    }
    return undefined;
}

function mapToSortType(value: SortableHeaders): SortType {
    const mapping: Record<SortableHeaders, SortType> = {
        actions: SortType.Action,
        total: SortType.Total,
        freelancer: SortType.Freelancer,
        freelancerPrice: SortType.FreelancerPrice,
        projectOwner: SortType.ProjectOwner,
        purchaseOrder: SortType.PurchaseOrder,
        company: SortType.Company,
        organization: SortType.Organization,
        title: SortType.ProjectTitle,
        startDate: SortType.StartDate,
        endDate: SortType.EndDate,
        sortDateForClient: SortType.SortDateForClient,
        status: SortType.Status,
        verticalType: SortType.VerticalType,
        opportunityType: SortType.OpportunityType,
        renewalStatus: SortType.RenewalStatus,
    };
    return mapping[value];
}

export {mapFromSortType, mapToSortType};
